module.exports = __webpack_public_path__ + "img/italicIcon.38f5268f.svg";